export default __webpack_public_path__ + "static/media/do-1@3x.3e37a10b.jpg";